import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import OTPModuleContent from './OTPModuleContent';
import useDebounce from '../../../common/components/UseDebounce';
import UpdateModal from '../components/UpdateModal';

const form = {
  keyword: '',
};

function OTPModuleContainer({
  match,
  history,
  isLoading,
  getOTPSettings,
  showOTPSettingsList,
  otpListPager,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update OTP',
      modalSize: 'modal-md',
    });
  };

  useEffect(() => {
    getOTPSettings();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);
  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getOTPSettings({ q: formData.keyword, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:otpId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="OTP Settings"
            // getData={showOTPSettingsList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:otpId?`}
            listName="OTP Module Settings"
            label="Settings List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <span style={{ color: '#2f89fc', fontWeight: 'bold' }}>
                  {_.get(item, 'attributes.type')}{' '}
                </span>
                <br />
              </div>
            )}
            isLoading={isLoading}
            selected={params.otpId}
            data={showOTPSettingsList}
            dataPager={otpListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:otpId?`}
                    render={() => (
                      <OTPModuleContent
                        handleEdit={handleEdit}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:otpId?`}
                  render={() =>
                    !params.otpId && showOTPSettingsList.length > 0 ? (
                      <Redirect to={`${match.url}/1`} />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

OTPModuleContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  // OTP
  getOTPSettings: PropTypes.instanceOf(Function).isRequired,
  showOTPSettingsList: PropTypes.instanceOf(Array).isRequired,
  otpListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  
};

const mapStateToProps = ({ api }) => ({
  showOTPSettingsList: _.get(api, `${c.GET_OTP_SETTINGS}.list`) || [],
  updateOTPSettings: _.get(api, `${c.UPDATE_OTP_SETTINGS}.list`) || [], 
  otpListPager: _.get(api, `${c.GET_OTP_SETTINGS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_OTP_SETTINGS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(OTPModuleContainer);
